<template>
    <modal :show.sync=show modalClasses="medium-sized-modal calculator-modal" bodyClasses="p-0" :hide-footer="true" @close="resetForm()">
        <h3 slot="header" class="mb-0 font-weight-500">RPGT Calculator</h3>

        <div v-loading="loading" class="p-4">
            <ValidationObserver v-slot="{ invalid }" ref="observer">
                <b-form ref="propertyIncomeForm" role="form" @submit.prevent="calculate()">
                    <div v-show="Object.keys(rpgtData).length === 0">
                        <b-row>
                            <b-col cols="12" md="6">
                                <b-form-group label="Purchase Date">
                                    <ValidationProvider
                                        v-slot="{ errors }"
                                        :rules="{ required: true }"
                                        :vid="'purchaseDate'"
                                    >
                                        <el-date-picker
                                        v-model="form.purchase_date"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="Pick Purchase Date">
                                        </el-date-picker>
                                        <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                    </ValidationProvider>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="6">
                                <b-form-group label="Selling Date">
                                    <ValidationProvider
                                        v-slot="{ errors }"
                                        :rules="{ required: true }"
                                        :vid="'sellingDate'"
                                    >
                                        <el-date-picker
                                        v-model="form.selling_date"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="Pick Selling Date">
                                        </el-date-picker>
                                        <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                    </ValidationProvider>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="6">
                                <b-form-group label="Purchase/Acquisition Price">
                                    <ValidationProvider
                                        v-slot="{ errors }"
                                        :rules="{ required: true }"
                                        :vid="'purchasePrice'"
                                    >
                                        <CurrencyInput
                                            v-model="form.acquisition_price"
                                            :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                                        />
                                        <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                    </ValidationProvider>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="6">
                                <b-form-group label="Selling/Disposal Price">
                                    <ValidationProvider
                                        v-slot="{ errors }"
                                        :rules="{ required: true }"
                                        :vid="'sellingPrice'"
                                    >
                                        <CurrencyInput
                                            v-model="form.disposal_price"
                                            :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                                        />
                                        <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                    </ValidationProvider>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="6">
                                <b-form-group label="Permitted Expenses">
                                    <ValidationProvider
                                        v-slot="{ errors }"
                                        :rules="{ required: true }"
                                        :vid="'permittedExpenses'"
                                    >
                                        <CurrencyInput
                                            v-model="form.expenses"
                                            :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                                        />
                                        <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                    </ValidationProvider>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="6">
                                <b-form-group label="Seller's Nationality">
                                    <ValidationProvider
                                        v-slot="{ errors }"
                                        :rules="{ required: true }"
                                        :vid="'sellersNationality'"
                                    >
                                        <el-select v-model="form.seller_nationality" placeholder="Select">
                                            <el-option
                                            v-for="item in nationalityOptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                        <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                    </ValidationProvider>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="6">
                                <b-form-group label="Residential Status">
                                    <ValidationProvider
                                        v-slot="{ errors }"
                                        :rules="{ required: true }"
                                        :vid="'residentialStatus'"
                                    >
                                        <b-form-radio-group
                                            id="radio-group-2"
                                            v-model="form.residential"
                                            name="Residential Status"
                                        >
                                            <b-form-radio :value="1">Residential</b-form-radio>
                                            <b-form-radio :value="0">Non-Residential</b-form-radio>
                                        </b-form-radio-group>
                                        <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                    </ValidationProvider>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>

                    <RPGTCalculatorTable v-if="Object.keys(rpgtData).length > 0" :rpgtData="rpgtData" />

                    <b-row>
                        <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                            <b-button type="submit" variant="primary" :disabled="invalid" v-show="Object.keys(rpgtData).length === 0">Calculate</b-button>
                            <b-button variant="primary" @click.prevent="resetForm">Reset</b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </ValidationObserver>
        </div>
    </modal>
</template>
<script>
import Modal from '@/components/Modal'
import { DatePicker, Select, Option } from 'element-ui'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import '@/assets/js/formValidations.js'
import CurrencyInput from '@/components/CurrencyInput'
import {
  notifyFunctionMixin,
  helperFunctionMixin,
  axios,
  services,
} from '@/assets/js/httpImports.js'
import RPGTCalculatorTable from '@/views/Calculators/CalculatorsTables/RPGTCalculatorTable'

export default {
    props: {
        rgpt_calculator: Boolean
    },
    mixins:[ notifyFunctionMixin, helperFunctionMixin ],
    components: {
        Modal,
        ValidationObserver,
        ValidationProvider,
        CurrencyInput,
        RPGTCalculatorTable,
        [DatePicker.name]: DatePicker,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
        return {
            loading: false,
            form: {
                purchase_date: '',
                selling_date: '',
                acquisition_price: 500000,
                disposal_price: 450000,
                expenses: 2500,
                seller_nationality: 'Citizen',
                residential: 1
            },
            nationalityOptions: [{
                value: 'Citizen',
                label: 'Citizen'
                }, {
                value: 'Permanent Resident',
                label: 'Permanent Resident'
                }, {
                value: 'Expats',
                label: 'Expats'
            }],
            rpgtData: {}
        }
    },
    computed: {
        show: {
            get() {
                return this.rgpt_calculator;
            },
            set(newVal) {
                this.$emit('update:rgpt_calculator', newVal);
            },
        },
    },
    methods: {
        preventNonNumericInput(event) {
            const keyCode = event.keyCode || event.which;
            const keyValue = String.fromCharCode(keyCode);
            const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
            const allowedKeys = [8, 37, 38, 39, 40, 46];
            if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
                event.preventDefault();
            }
        },
        calculate() {
            this.loading = true
            let requestData = {
                calculator: this.form,
                client_token: 'clzNYY762WEHTP'
            }

            let url = `${services.fintos_calculator}rpgt`
			axios.post(url, requestData)
			.then(res => {
				this.loading = false
                this.rpgtData = res.data.data
			})
			.catch(e => {
				this.errorFunction(e)
			})
        },
        resetForm() {
            this.form = {
                purchase_date: '',
                selling_date: '',
                acquisition_price: 500000,
                disposal_price: 450000,
                expenses: 2500,
                seller_nationality: 'Citizen',
                residential: 1
            }

            this.rpgtData = {}
        }
    }
}
</script>